// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();

document.querySelectorAll("[data-copy]").forEach((button) => {
    button.addEventListener("click", async () => {
        const value = button.getAttribute("data-copy");
        try {
            await navigator.clipboard.writeText(value);
        } catch (error) {
            return;
        }
        const hint = button.querySelector(".bx-code-hint");
        button.classList.add("is-copied");
        if (hint) hint.textContent = button.getAttribute("data-copied") || hint.textContent;
    });
});